import React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import Footer from '../components/Footer';
import InnerPageHeader from '../components/InnerPageHeader';
import {
  InnerCard,
  InnerContainer,
  InnerSection,
  PageTitle,
  Paragraph,
} from '../components/InnerPageLayout';

const HomeLink = styled(Link)`
  display: inline-block;
  margin-top: 8px;
  padding: 12px 28px;
  background: linear-gradient(135deg, #1c3650 0%, #2a4a6a 100%);
  color: #fff;
  font-weight: 500;
  text-decoration: none;
  border-radius: 8px;
  transition: transform 0.2s ease, box-shadow 0.2s ease;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 8px 20px rgba(28, 54, 80, 0.25);
  }
`;

const NotFound: React.FC = () => (
  <>
    <InnerPageHeader
      data={{
        title: 'Page Not Found',
        paragraph: "The page you're looking for doesn't exist or has been moved.",
      }}
    />
    <InnerSection>
      <InnerContainer>
        <InnerCard>
          <PageTitle>404 - Page Not Found</PageTitle>
          <Paragraph>
            Sorry, we couldn't find the page you were looking for. It may have been removed,
            renamed, or didn't exist in the first place.
          </Paragraph>
          <Paragraph>
            You can return to our homepage to find what you're looking for.
          </Paragraph>
          <HomeLink to="/">Back to Home</HomeLink>
        </InnerCard>
      </InnerContainer>
    </InnerSection>
    <Footer />
  </>
);

export default NotFound;
